import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

/**
 * simCoverageInfoSearch — powers the country search inside
 * SimCoverageInfoB2B. Filters the already server-rendered
 * `.sim-coverageInfoB2B__tagsGrid-item` list by matching the query against
 * each item's `data-country`, so the grid keeps its fixed height (no layout
 * jump) while the country count is announced for assistive tech.
 */

const DIACRITICS_REGEX = new RegExp(
  `[${String.fromCharCode(0x0300)}-${String.fromCharCode(0x036f)}]`,
  "g",
);

/** Lowercase + strip diacritics so "papua" matches "Papua". */
function normalize(value: string): string {
  return value
    .normalize("NFD")
    .replace(DIACRITICS_REGEX, "")
    .toLowerCase()
    .trim();
}

export class SimCoverageInfoSearch implements Plugin {
  private input: HTMLInputElement | null = null;
  private items: HTMLElement[] = [];
  private status: HTMLElement | null = null;

  private readonly onInput = () => this.filter();

  constructor(private readonly element: HTMLElement) {}

  init(): void {
    this.input = this.element.querySelector<HTMLInputElement>(
      ".sim-coverageInfoB2B__search input",
    );
    this.items = Array.from(
      this.element.querySelectorAll<HTMLElement>(
        ".sim-coverageInfoB2B__tagsGrid-item",
      ),
    );
    this.status = this.element.querySelector(".sim-coverageInfoB2B__status");

    this.input?.addEventListener("input", this.onInput);
  }

  destroy(): void {
    this.input?.removeEventListener("input", this.onInput);
  }

  private filter(): void {
    const query = normalize(this.input?.value ?? "");
    let visibleCount = 0;

    this.items.forEach((item) => {
      const country = normalize(item.dataset.country ?? "");
      const isMatch = !query || country.includes(query);
      item.classList.toggle("is-hidden", !isMatch);
      if (isMatch) visibleCount += 1;
    });

    if (this.status) {
      this.status.textContent = query
        ? `${visibleCount} ${visibleCount === 1 ? "país encontrado" : "países encontrados"}`
        : "";
    }
  }
}

PluginRegistry.register("simCoverageInfoSearch", SimCoverageInfoSearch);
